<header class="relative bg-white shadow-sm">
  <div class="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-2 flex justify-between items-center">
    <div class="flex items-center space-x-8">
      <a href="/" tabindex="-1" class="flex items-center">
        <img
          ngSrc="assets/images/agw-logo.png"
          alt="AGW Logo"
          class="h-8 rounded-sm"
          height="32"
          width="32"
        />
        <span class="ml-3 text-lg font-medium text-gray-900 hidden md:block">Tracer</span>
      </a>
    </div>

    @if (!!keycloak.authenticated) {
      <div class="flex flex-col space-y-1 flex-1 max-w-xl mx-2">
        <div class="flex items-center space-x-4">
          <div class="relative flex-1">
            <input
              type="text"
              [(ngModel)]="query"
              placeholder="Search by Request ID, Session ID, AGW Order ID or PNR..."
              class="text-sm w-full pl-3 pr-8 py-1 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            />
          </div>
          <button class="btn btn-sm btn-primary rounded" (click)="search()">Search</button>
        </div>

        @if (queryError) {
          <small class="text-primary pl-1">
            {{ queryError }}
          </small>
        }
      </div>

      <div class="dropdown dropdown-end">
        <div
          #dropdownTrigger
          tabindex="0"
          role="button"
          class="flex items-center space-x-2 text-gray-700 hover:text-primary focus:outline-none"
        >
          <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
            <i class="ri-user-line text-gray-600"></i>
          </div>
          <div class="hidden md:block text-left">
            <p class="text-sm font-medium">{{ email }}</p>
          </div>
          <div class="w-5 h-5 flex items-center justify-center">
            <i class="ri-arrow-down-s-line"></i>
          </div>
        </div>

        <ul
          tabindex="0"
          class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52 mt-4"
        >
          @if (agRealm === 'agents') {
            <!-- My Agencies submenu -->
            <li tabindex="0">
              <details class="open:bg-slate-50 rounded" open>
                <summary>My Agencies</summary>
                <ul class="p-2 m-0 max-h-64 overflow-auto list-none before:content-none">
                  @for (agency of agencies; track agency.id) {
                    <li
                      class="rounded mb-1 last:mb-0"
                      [ngClass]="{ 'bg-primary/10': agency.id === currentAgency?.id }"
                    >
                      <a
                        (click)="agency.id !== currentAgency?.id ? switchAgency(agency) : null"
                        class="flex gap-3 items-center px-2 py-1 rounded hover:bg-primary/10"
                      >
                        <div
                          class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center font-semibold text-sm text-gray-700"
                          [ngClass]="{ 'ring-2 ring-primary/10': agency.id === currentAgency?.id }"
                        >
                          {{ agency.name.charAt(0).toUpperCase() }}
                        </div>

                        <!-- Agency info -->
                        <div class="flex flex-col">
                          <div class="font-semibold">{{ agency.name }}</div>
                          @if (agency.iata_number) {
                            <div class="text-xs text-gray-500">
                              {{ agency.iata_number }}
                            </div>
                          }
                        </div>
                      </a>
                    </li>
                  }
                </ul>
              </details>
            </li>
          }

          @if (agRealm === 'admins') {
            <!-- Sits directly under the signed-in identity on purpose:
                 a personal token IS this user, so its management lives
                 next to who you are, not with the instance settings. -->
            <li>
              <a
                [routerLink]="['/admin/settings/tokens']"
                (click)="dropdownTrigger.blur()"
                class="flex gap-2 items-center"
              >
                <i class="ri-key-2-line"></i>
                Personal Tokens
              </a>
            </li>
            <li>
              <a
                [routerLink]="['/admin/reports']"
                (click)="dropdownTrigger.blur()"
                class="flex gap-2 items-center"
              >
                <i class="ri-bar-chart-2-line"></i>
                Reports
              </a>
            </li>
            <li>
              <a
                [routerLink]="['/admin/settings']"
                (click)="dropdownTrigger.blur()"
                class="flex gap-2 items-center"
              >
                <i class="ri-settings-3-line"></i>
                Settings
              </a>
            </li>
          }

          <li class="text-red-600">
            <a (click)="authService.logout(); dropdownTrigger.blur()">Logout</a>
          </li>
        </ul>
      </div>
    }
  </div>
</header>
